import type { Fields } from "@vuex-orm/core";
// eslint-disable-next-line import/no-cycle
import { Slide } from "./ActionHierarchy";
import type { ActionWithDuration } from "./ActionTypes";
import Video from "./Video";

export class LinkedVideoSlide extends Slide implements ActionWithDuration {
  // This is the name used as module name of the Vuex Store.
  public static entity = "linkedVideoSlides";

  public static baseEntity = "actions";

  public readonly isBrowserAction = false;

  public static fields(): Fields {
    return {
      ...super.fields(),
      linkedVideoId: this.number(0),
      linkedVideo: this.belongsTo(Video, "linkedVideoId"),
    };
  }

  public declare linkedVideoId: number;

  public declare linkedVideo: Video;

  public static get humanName(): string {
    return "Linked Video";
  }

  public get duration(): number {
    console.warn("LinkedVideoSlide#duration is not implemented");
    return 10.0;
  }
}
